// extracted by mini-css-extract-plugin
export default {"providerAccountTab":"providerAccountTab__Yzcyxj"};